import React from "react";
import data from "../Data";
import Btn from "../../../ReUseAbleComp/Button.jsx";
import Header from "../../../ReUseAbleComp/Header.jsx";
import Search from "../../../ReUseAbleComp/SearchInput.jsx";

function LGEnglish({
  GeneralsearchResults,
  GeneralPashtoSearch,
  handleGeneralChange,
  searchTagPashto,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>جنرال</h1>

        <Search
          handleChange={handleGeneralChange}
          searchTerm={GeneralPashtoSearch}
          searchTagPashto={searchTagPashto}
          dir="rtl"
        />

        {GeneralPashtoSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Ptitle}
            id={item.RID}
            path={`/GeneralPashtoDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
